"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useContext, useEffect } from "react";
import { AccountContext } from "../account-provider/account-provider";
export function useAccount(accountInput) {
    var _a = useContext(AccountContext), set = _a.set, x = __rest(_a, ["set"]);
    useEffect(function () {
        if (accountInput) {
            set(accountInput);
        }
    }, [accountInput]);
    return x;
    /*
    const payment = useRemoteList();
    const travelers = useRemoteList();
    const phones = useRemoteList();
  
    return { account, payment, travelers, phones };
    */
}
export function useRemoteList() {
    var add = useCallback(function () { }, []);
    var remove = useCallback(function () { }, []);
    var update = useCallback(function () { }, []);
    return [{}, { add: add, remove: remove, update: update }];
}
